import React from 'react';

import Modal from '~/components/modals/modal';

import styles from '~/components/modals/modal.module.scss';

const PrivacyModal = ({ onClose, isOpen }) => {
  return (
    <Modal onClose={onClose} isOpen={isOpen}>
      <PrivacyModalContent />
    </Modal>
  );
};

const PrivacyModalContent = () => {
  return (
    <div className={styles.privacyModalContent}>
      <h1>Science, not spam</h1>
      <p>
        We use your address to calculate your yard size and analyze your
        historical rainfall, temps, soil profile and growth potential to build a
        lawn plan tailored just for you. Your privacy matters to us!
      </p>
    </div>
  );
};

export default PrivacyModal;
